var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7189 49.2188C31.7189 50.089 32.0646 50.9236 32.68 51.5389C33.2953 52.1543 34.1299 52.5 35.0001 52.5C35.8704 52.5 36.705 52.1543 37.3203 51.5389C37.9357 50.9236 38.2814 50.089 38.2814 49.2188C38.2814 48.3485 37.9357 47.5139 37.3203 46.8986C36.705 46.2832 35.8704 45.9375 35.0001 45.9375C34.1299 45.9375 33.2953 46.2832 32.68 46.8986C32.0646 47.5139 31.7189 48.3485 31.7189 49.2188V49.2188ZM32.8126 28.4375V41.0156C32.8126 41.3164 33.0587 41.5625 33.3595 41.5625H36.6408C36.9416 41.5625 37.1876 41.3164 37.1876 41.0156V28.4375C37.1876 28.1367 36.9416 27.8906 36.6408 27.8906H33.3595C33.0587 27.8906 32.8126 28.1367 32.8126 28.4375ZM65.3312 58.5156L36.8937 9.29688C36.4699 8.56543 35.7384 8.20312 35.0001 8.20312C34.2619 8.20312 33.5236 8.56543 33.1066 9.29688L4.66909 58.5156C3.82827 59.9785 4.881 61.7969 6.56265 61.7969H63.4376C65.1193 61.7969 66.172 59.9785 65.3312 58.5156ZM11.7716 56.6084L35.0001 16.3994L58.2287 56.6084H11.7716V56.6084Z",
    fill: "#BE322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.91e9f3318eb27e13bf050c27f08532af.svg";
export { ForwardRef as ReactComponent };